<template>
  <MainComp />
</template>

<script>
  import MainComp from '../components/MainComp'

  export default {
    name: 'MainView',

    components: {
      MainComp,
    },
  }
</script>
